:host {
    display: block;
  }
  
  .horizontal {
    width: 100%;
    height: 1px;
    background-color: rgba(0, 0, 0, 0.12);
    min-width: 1px;
  }
  
  .vertical {
    width: 1px;
    background-color: rgba(0, 0, 0, 0.12);
    min-height: 1px;
  }
  